import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { PrivacidadPage } from '@/components/marketing/LegalPages';

export const Route = createFileRoute('/_public/privacidad')({
  component: () => (
    <MarketingShell currentPath="/privacidad">
      <PrivacidadPage />
    </MarketingShell>
  ),
});
